import Link from "next/link";

type TagsProps = {
	tags: any[];
	kind: any;
	news?: boolean;
};

const Tags = ({ tags, kind, news = false }: TagsProps) => (
	<div className="flex flex-wrap gap-2">
		{tags.map((tag: any, index: number) => {
			return (
				<Link
					key={index}
					className="block text-center text-[8px] md:text-[10px] lg:text-[12px] px-3 py-1 text-white/[.50] bg-white/[.12] hover:opacity-70"
					href={`${news ? "/news" : ""}/${kind.kind}/tags/${tag.id}`}
				>
					{tag.title}
				</Link>
			);
		})}
	</div>
);

export default Tags;
